var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1117.749,
    height: 650.358,
    viewBox: "0 0 770 650.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ag,.c,.d,.e,.j,.l,.z{fill:none;}.b{fill:#ebebeb;}.c,.e{stroke:#c7c7c7;}.c,.d,.f,.j,.l{stroke-miterlimit:10;}.c,.d{stroke-width:1.09px;}.d,.l,.z{stroke:#fff;}.ag,.e,.z{stroke-linecap:round;stroke-linejoin:round;}.e{stroke-width:1.1px;}.f,.t{fill:#fff;}.f,.j{stroke:#ebebeb;}.g{fill:#80a3fc;}.h{fill:#364380;}.i{fill:#e6c732;}.j{stroke-width:2.21px;}.k{fill:#c3643b;}.l{stroke-width:2.02px;}.m{fill:#e9a52a;}.n{fill:#f0c941;}.o{fill:#db3569;}.p{fill:#de5177;}.q{fill:#f5f5f5;}.r{opacity:0.71;}.s{clip-path:url(#a);}.u{fill:#c7c7c7;}.v{fill:#666;}.w{fill:#494949;}.x{fill:#e48580;}.y{fill:#202443;}.z{stroke-width:1.5px;}.aa{fill:#ecaf9c;}.ab{fill:#df8298;}.ac{fill:#60a9a5;}.ad{fill:#3a706c;}.ae{fill:#ac91d0;}.af{fill:#322b2a;}.ag{stroke:#322b2a;stroke-width:0.6px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 114.414,
    cy: 114.414,
    r: 114.414
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80.86 -65.975)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M255.154,427.319a135.7,135.7,0,0,1,27.7,6.093h0l.362.133,1.009.343c50.267,17.936,73.363,14.566,93.127,8.492,53.313-16.394,85.035-86.977,171.5-73.306,36.672,5.712,66.166,13.671,89.167,29.7h0c.171.152.324.248.495.381,3.294,2.323,6.512,4.684,9.52,7.1,44.974,29.341,89.776-8.911,102.628-17.574.952-.685,1.9-6.131,2.894-6.816l.8-.609h0c56.341-39.718,145.964-79.97,232.294-70.069,148.516,16.965,208.188,185.321,208.188,185.321H85.58C102.907,456.66,172.214,417.837,255.154,427.319Z",
    transform: "translate(3.77 219.821)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 15.175,
    cy: 15.385,
    rx: 15.175,
    ry: 15.385,
    transform: "translate(103.364 311.076)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 15.175,
    cy: 15.385,
    rx: 15.175,
    ry: 15.385,
    transform: "translate(563.039 66.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M401.7,89.884a5.712,5.712,0,1,1-5.712-5.864A5.827,5.827,0,0,1,401.7,89.884Z",
    transform: "translate(279.234 15.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M81.41,124.954H329.088s-1.18-9.825-28.713-17.708-47.258,12.3-78.371,0S174.4,77.315,134.419,87.14,81.41,124.954,81.41,124.954Z",
    transform: "translate(0 16.052)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 435.836,
    height: 437.226,
    transform: "translate(399.9 276.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M684.536,152.613v68.812H248.68V152.613a24.753,24.753,0,0,1,24.753-24.753h386.35a24.753,24.753,0,0,1,24.753,24.753Z",
    transform: "translate(151.22 55.454)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 20.507,
    cy: 20.507,
    r: 20.507,
    transform: "translate(747.693 205.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M447.688,190.7h0a11.748,11.748,0,0,0,11.748-11.748V125.868a11.748,11.748,0,0,0-11.748-11.748h0a11.748,11.748,0,0,0-11.748,11.748v53.085A11.748,11.748,0,0,0,447.688,190.7Z",
    transform: "translate(320.512 43.033)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 20.507,
    cy: 20.507,
    r: 20.507,
    transform: "translate(602.986 205.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M371.688,190.7h0a11.748,11.748,0,0,0,11.748-11.748V125.868a11.748,11.748,0,0,0-11.748-11.748h0a11.748,11.748,0,0,0-11.748,11.748v53.085A11.748,11.748,0,0,0,371.688,190.7Z",
    transform: "translate(251.804 43.033)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 20.507,
    cy: 20.507,
    r: 20.507,
    transform: "translate(458.278 205.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M295.688,190.7h0a11.748,11.748,0,0,0,11.748-11.748V125.868a11.748,11.748,0,0,0-11.748-11.748h0a11.748,11.748,0,0,0-11.748,11.748v53.085A11.767,11.767,0,0,0,295.688,190.7Z",
    transform: "translate(183.097 43.033)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(771.341 429.983) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(661.097 429.983) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(550.834 429.983) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(771.341 535.163) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(661.097 535.163) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 82.864,
    height: 82.864,
    transform: "translate(550.834 535.163) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "l",
    x2: 22.982,
    y2: 23.686,
    transform: "translate(497.901 481.888)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "l",
    x1: 22.982,
    y2: 23.686,
    transform: "translate(497.901 481.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(771.341 640.362) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(661.097 640.362) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 82.864,
    height: 82.864,
    transform: "translate(550.834 640.362) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 40.328,
    height: 26.561,
    transform: "translate(787.945 425.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M507.133,269.253H454.391A10.891,10.891,0,0,1,443.5,258.362h0a10.891,10.891,0,0,1,10.891-10.872h52.742a10.872,10.872,0,0,1,10.872,10.872h0a10.872,10.872,0,0,1-10.872,10.891Z",
    transform: "translate(327.346 163.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 32.159,
    height: 22.677,
    transform: "translate(687.583 489.003) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M437.2,282.672l-31.76,31.7a8.207,8.207,0,0,1-11.6,0h0a8.207,8.207,0,0,1,0-11.6l31.76-31.76a8.206,8.206,0,0,1,11.6,0h0a8.206,8.206,0,0,1,0,11.653Z",
    transform: "translate(280.291 182.708)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 136.311,
    cy: 136.311,
    r: 136.311,
    transform: "translate(671.322 441.084)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 128.98,
    cy: 128.98,
    r: 128.98,
    transform: "translate(678.652 448.415)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 114.414,
    cy: 114.414,
    r: 114.414,
    transform: "translate(693.218 462.981)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(693.218 462.981)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M397.08,305.9,570.5,574.613l78.333-67.384L477.259,266.71Z",
    transform: "translate(-407.838 -281.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M445.62,255.894l173.4,268.718,10.092-33.683L457.539,250.41Z",
    transform: "translate(-363.955 -296.735)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M464.494,294.376a2.875,2.875,0,0,1-2.875-2.875v-6.759a2.875,2.875,0,1,1,5.712,0V291.5a2.894,2.894,0,0,1-2.837,2.875Z",
    transform: "translate(343.709 194.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M464.485,394.453a2.856,2.856,0,0,1-2.875-2.875v-6.759a2.875,2.875,0,0,1,5.712,0v6.759a2.875,2.875,0,0,1-2.837,2.875Z",
    transform: "translate(343.719 285.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M432.517,307.462a2.875,2.875,0,0,1-2.037-.838l-4.779-4.779a2.881,2.881,0,0,1,4.075-4.075l4.779,4.779a2.875,2.875,0,0,1,0,4.075,2.913,2.913,0,0,1-2.037.838Z",
    transform: "translate(310.492 208.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M503.507,378.452a2.913,2.913,0,0,1-2.037-.838l-4.779-4.779a2.881,2.881,0,1,1,4.075-4.075l4.779,4.779a2.875,2.875,0,0,1,0,4.075A2.913,2.913,0,0,1,503.507,378.452Z",
    transform: "translate(374.67 272.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M427.739,378.468a2.913,2.913,0,0,1-2.037-.838,2.875,2.875,0,0,1,0-4.075l4.779-4.779a2.915,2.915,0,1,1,4.17,4.075l-4.874,4.76a2.914,2.914,0,0,1-2.037.857Z",
    transform: "translate(310.491 272.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M498.729,307.462a2.913,2.913,0,0,1-2.037-.838,2.875,2.875,0,0,1,0-4.075l4.779-4.779a2.881,2.881,0,0,1,4.075,4.075l-4.779,4.741A2.913,2.913,0,0,1,498.729,307.462Z",
    transform: "translate(374.669 208.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M419.118,339.412h-6.759a2.875,2.875,0,0,1,0-5.712h6.759a2.875,2.875,0,0,1,0,5.712Z",
    transform: "translate(296.892 241.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M519.507,339.412h-6.759a2.875,2.875,0,0,1,0-5.712h6.759a2.875,2.875,0,0,1,0,5.712Z",
    transform: "translate(387.649 241.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M473.257,366.2H459.51V306.583a6.874,6.874,0,0,1,6.874-6.893h0a6.893,6.893,0,0,1,6.873,6.893Z",
    transform: "translate(341.82 210.797)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 15.766,
    cy: 15.766,
    r: 15.766,
    transform: "translate(792.438 561.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M244.487,261.617l24.9,109.863a29.665,29.665,0,0,1-10.529,27.4L184.49,457.03l1.371-53.561,37.148-30.313L184.49,258.59Z",
    transform: "translate(93.189 173.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M173.612,381.42l35.815-18.736L195.28,342.73l-38.9,21.135,12.414,15.747Z",
    transform: "translate(67.776 249.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M171.071,349.42s6.055,22.182,23.477,20.944l6.721,52.856L149.86,358.026Z",
    transform: "translate(61.882 255.755)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 83.035,
    height: 7.845,
    transform: "translate(211.655 613.772) rotate(51.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M178.5,364.556a31.474,31.474,0,0,0-10.015-1.009",
    transform: "translate(78.715 268.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M179.285,368.616a31.586,31.586,0,0,0-10.015-1.009",
    transform: "translate(79.43 272.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M180.065,372.688a30.921,30.921,0,0,0-10.015-1.009",
    transform: "translate(80.135 275.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M193.828,416.5l3.618-39.718-24.429-1.257-3.637,43.641h20.05Z",
    transform: "translate(79.529 279.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M170.778,394.715s21.173,8.987,30.979-5.465l45.7,27.437H164.38Z",
    transform: "translate(75.009 291.763)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 83.035,
    height: 7.845,
    transform: "translate(239.389 708.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M190.477,391.13a31.36,31.36,0,0,0-7.007,7.235",
    transform: "translate(92.267 293.463)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M194.138,393a30.978,30.978,0,0,0-6.988,7.254",
    transform: "translate(95.594 295.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M197.827,394.93a31.245,31.245,0,0,0-7.007,7.254",
    transform: "translate(98.912 296.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M178.1,258.77,166.9,490.454h42.5l30.96-230.923Z",
    transform: "translate(77.287 173.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M230.77,260.659h0l-25.762,40.385L199.62,259.65Z",
    transform: "translate(106.867 174.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M286.041,250.735l-25.381,1.98,4.532-25.5,26.523,2.228Z",
    transform: "translate(162.05 145.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M299.173,253.783a17.8,17.8,0,1,1,1.9-25.1A17.8,17.8,0,0,1,299.173,253.783Z",
    transform: "translate(170.282 140.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M289.056,224.368s-3.218-7.445-10.758-1.9-14.223,16.794-3.675,31.264Z",
    transform: "translate(169.736 139.127)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M279.61,224.958l20.45-5.141a3.332,3.332,0,0,1,4.151,2.018h0a2.875,2.875,0,0,1-1.523,3.618l-20.773,9.292Z",
    transform: "translate(179.182 138.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M241.934,208.821l33.53,53.066a18.565,18.565,0,0,1-6.055,24.562h0a18.546,18.546,0,0,1-25.628-5.331l-36.958-50.99a20.526,20.526,0,0,1,2.628-25.838h0a20.545,20.545,0,0,1,32.483,4.532Z",
    transform: "translate(110.308 119.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M218.14,246.747l1.98-29.037,7.2,41.718Z",
    transform: "translate(123.61 136.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M239.465,233.012l73.82-8.682-.228,33.644-68.66,8.854A17.136,17.136,0,0,1,224,249.444h0a17.136,17.136,0,0,1,15.461-16.432Z",
    transform: "translate(128.904 142.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M174.239,294.393s8.225.647,6.893-8.759-8.3-20.83-26.352-18.26Z",
    transform: "translate(66.33 181.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae",
    width: 82.864,
    height: 82.864,
    transform: "translate(263.894 551.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae",
    width: 82.864,
    height: 82.864,
    transform: "translate(267.721 551.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M147.787,289.025a18.107,18.107,0,1,1,7.952,11.363A18.126,18.126,0,0,1,147.787,289.025Z",
    transform: "translate(59.614 181.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M182.441,239.719l-.819,74.258-32.559-1.523-.876-72.22A17.136,17.136,0,0,1,168.1,222.221h0A17.136,17.136,0,0,1,182.441,239.719Z",
    transform: "translate(60.337 140.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M224.048,232.125l-44.916,43.793a18.545,18.545,0,0,1-25.286-.8h0a18.564,18.564,0,0,1-.133-26.181l42.175-46.763a20.545,20.545,0,0,1,25.819-2.8h0a20.564,20.564,0,0,1,2.342,32.75Z",
    transform: "translate(60.543 117.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M252.116,200.27,188.235,196c-5.712-.381-16.032,10.091-15.423,15.823V315.465l82.255,2.685,8.34-105.2a12.072,12.072,0,0,0-11.291-12.681Z",
    transform: "translate(82.609 117.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M172.78,238.517l18.545-18.107L172.8,269.439Z",
    transform: "translate(82.603 139.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M209.006,179.51a8.454,8.454,0,1,0,9.158-7.959,8.549,8.549,0,0,0-9.158,7.959Z",
    transform: "translate(115.341 94.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M217.808,191.535l-.4,20.849c-.114,7.331-4.551,11.158-11.539,10.967h0c-5.96-.171-12.452-3.2-12.072-9.653l2.133-32.788Z",
    transform: "translate(101.589 103.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M216.748,203.434s-17.022,1.123-21.954-18.107c-1.542-6.074,22.239,2.094,22.239,2.094Z",
    transform: "translate(102.44 105.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M214.644,220.39h0c11.9.248,21.916-9.254,22.449-19.288l1.009-20.945a23.077,23.077,0,0,0-20.6-24.524h0c-12.433-1.123-25.59,8.187-26.657,21.04l-.59,16.375A26.2,26.2,0,0,0,214.644,220.39Z",
    transform: "translate(98.374 80.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M209.479,174.64l.552,6.874-2.951.057",
    transform: "translate(113.612 97.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M203.985,167.339s4.893-.324,4.912,1.733c0,0,0,1.39-4.3,1.58s-5.369-.133-5.712-1.447S201.7,167.32,203.985,167.339Z",
    transform: "translate(106.177 91.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M214.34,169.887s-4.018-.5-4.379,1.428c0,0-.21,1.295,3.313,1.657s4.665,0,5.027-1.123S216.263,169.963,214.34,169.887Z",
    transform: "translate(116.214 93.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M210.65,174.959a2.076,2.076,0,1,0,.655-1.458,2.057,2.057,0,0,0-.655,1.458Z",
    transform: "translate(116.839 96.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M201.23,174.42a2.076,2.076,0,1,0,.661-1.446,2.056,2.056,0,0,0-.661,1.446Z",
    transform: "translate(108.323 95.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M203.82,179.84a6.816,6.816,0,0,0,6.836,2.247",
    transform: "translate(110.664 102.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M237.071,150.969c-4.57-1.9-16.223-4.132-18.793,6.169-11.577-.876-30.027-.666-31.874,9.387-2.723,14.756,7.749,29.4,7.749,29.4l2.951,1.5s7.483-3.808,5.56-21.573c0,0,26.79,6.455,39.357-.343S250.78,156.852,237.071,150.969Z",
    transform: "translate(94.511 74.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M184.5,178.624a8.568,8.568,0,0,0,7.616,9.368,8.473,8.473,0,0,0,9.082-7.864,8.387,8.387,0,1,0-16.7-1.5Z",
    transform: "translate(93.16 94.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M192.791,179.237s.533-6.245-5.331-5.712",
    transform: "translate(95.874 96.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M189.55,196.58l38.214,2.513s1.219,13.176-15.785,12.262C192.863,210.327,189.55,196.58,189.55,196.58Z",
    transform: "translate(97.764 117.58)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleImg);
export default __webpack_public_path__ + "static/media/scheduleImg.f9134d5a99ed7e48d953dbd3cae5a6dd.svg";
export { ForwardRef as ReactComponent };